module.exports = __webpack_public_path__ + "static/media/slackEmoji8.9f21df51.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/slackEmoji8.gif
// module id = 42
// module chunks = 0